/**
 * Types de flux d'opération (utilisé eseulmeent en France actuellement)
 * @type {{PASS_CARD: {i18nCode: string, code: string}, BANK_CARD: {i18nCode: string, code: string}}}
 */
const STREAM_TYPE = {
    BANK_CARD: {code: 'BANK_CARD', i18nCode: 'streamType.bankCard'},
    PASS_CARD: {code: 'PASS_CARD', i18nCode: 'streamType.passCard'}
};

/**
 * Récupère la liste des type de flux en fonction du pays, pour le moment seulement la France est concernée
 * @param location
 * @returns {null|*}
 */
export function getStreamTypeListFromLocation(location)  {
    // !!! TODO LEO CACHE_PASS !!! code commenté pour ne pas afficher la gestion des flux en attendant le go MarketPay , ATTENTION !! : Object.entries ne fonctionne pas sur IE11
    // if (!!location) {
    //     if(location === LOCATION.FR) {
    //         return Object.entries(STREAM_TYPE);
    //     }
    // }
    return null;
}

export default STREAM_TYPE


// WEBPACK FOOTER //
// ./src/enums/StreamType.js